module.exports = __webpack_public_path__ + "img/PL08732.d9666a9b.png";